/* eslint-disable @typescript-eslint/prefer-for-of */
import { Injectable } from '@angular/core';
import { FileModel, ColumnModel, listToDictionary, ErrorCodes, DataModel } from '@shared';
import { LoggingService } from '@shared/logging';
import { MigrationManagerService } from '../migration';
import { DataSchemaBuilder, WorkspaceDatabaseKeys } from '../schemas';
import { WorkspaceDatabaseProvider } from '../workspace-database.provider';
import { DynamicSchemaService } from './dynamic-schemas.service';

@Injectable({
	providedIn: 'root'
})
export class WorkspaceSchemaGeneratorService {
	public constructor(
		private dbProvider: WorkspaceDatabaseProvider,
		private dynamicSchemaService: DynamicSchemaService,
		private loggerService: LoggingService
	) {}

	public async generateSchemas(file: FileModel): Promise<void> {
		// build dictionary with table_name as grouping and list of columns for each table;
		const tableWithColumns: { [id: number]: ColumnModel[] } = listToDictionary(
			WorkspaceDatabaseKeys.tables.tableName,
			file.FusionDataColumns
		);

		try {
			for (let index = 0; index < file.FusionDataTables.length; index++) {
				const table = file.FusionDataTables[index];
				const listOfColumns = tableWithColumns[table.table_name];
				const currentSchemaBuilder = new DataSchemaBuilder();
				listOfColumns.forEach((column: ColumnModel) => {
					currentSchemaBuilder.addProperty(column.column_name, column.data_type);
				});
				// add table_name as column
				currentSchemaBuilder.addProperty(WorkspaceDatabaseKeys.columns.tableName, 'CHAR');
				const collectionName = table.table_name.toLowerCase();
				// create builder
				const schema = currentSchemaBuilder.buildWithLocalRxdbProperties();
				const collection = {};

				// this is for backwards compatibility, the schema functions are not saved locally
				const migrationStrategies = {};
				for (let i = 1; i <= MigrationManagerService.currentDatabaseVersion; i++) {
					migrationStrategies[i] = (record: DataModel) => record;
				}

				collection[collectionName] = {
					schema,
					autoMigrate: false,
					migrationStrategies
				};
				const databaseIntance = this.dbProvider.getCurrentDatabaseInstance();
				await this.dynamicSchemaService.saveToLocal(databaseIntance, collectionName, schema);
				await databaseIntance.addCollections(collection);
			}
		} catch (error) {
			this.loggerService.error(ErrorCodes.WorkspaceSchemaGeneratorService, error);
			throw error;
		}
	}
}
